import React from "react";

export const isEventHandled = (e: React.KeyboardEvent | React.MouseEvent) => {
  return e.isDefaultPrevented() || e.isPropagationStopped();
};
